import { Page } from "@serpro/ngx-suite-rfb";
import { Estado } from "./main/estado";


export class EstadoGerirTipoSegmento extends Estado {
    id = 'StateGerirTipoSegmento';

    filtroNome = '';
    filtroSigla = '';
    indiceOrdenacao: number|undefined;
    ascOrdenacao: boolean|undefined;
    pageSize = 100;
    currentPage: Page = { first: 0, last: this.pageSize, number: 1 };
}